import { ProductAdditives } from '../../../../services/exports/Constants';

export default {
  title: 'Additives',
  options: {
    [ProductAdditives.AcesulfamK]: 'Acesulfame K',
    [ProductAdditives.AceSucralose]: 'Ace-Sucralose',
    [ProductAdditives.Aesculin]: 'Aesculin',
    [ProductAdditives.Agar]: 'Agar',
    [ProductAdditives.Anthocyanin]: 'Anthocyanin',
    [ProductAdditives.Antioxidant]: 'Antioxidant',
    [ProductAdditives.AntioxidantAscorbicAcid]: 'Antioxidant: Ascorbic Acid',
    [ProductAdditives.AntioxidantTocopherols]: 'Antioxidant: Tocopherols',
    [ProductAdditives.Flavor]: 'Flavor',
    [ProductAdditives.Flavors]: 'Flavors',
    [ProductAdditives.AscorbicAcid]: 'Ascorbic Acid',
    [ProductAdditives.Aspartame]: 'Aspartame',
    [ProductAdditives.OysterSauce]: 'Oyster Sauce',
    [ProductAdditives.BakingAid]: 'Baking Aid',
    [ProductAdditives.BakingPowder]: 'Baking Powder',
    [ProductAdditives.BalsamicVinegar]: 'Balsamic Vinegar',
    [ProductAdditives.BalsamicCream]: 'Balsamic Cream',
    [ProductAdditives.BasilPesto]: 'Basil Pesto',
    [ProductAdditives.BenzoicAcid]: 'Benzoic Acid',
    [ProductAdditives.BetaCarotene]: 'Beta-Carotene',
    [ProductAdditives.Betain]: 'Betaine',
    [ProductAdditives.BeetrootRed]: 'Beetroot Red',
    [ProductAdditives.Beeswax]: 'Beeswax',
    [ProductAdditives.Bitters]: 'Bitters',
    [ProductAdditives.BlueCuracao]: 'Blue Curaçao',
    [ProductAdditives.BlueCuracaoSyrup]: 'Blue Curaçao Syrup',
    [ProductAdditives.BrandyVinegar]: 'Brandy Vinegar',
    [ProductAdditives.Broth]: 'Broth',
    [ProductAdditives.Caffeine]: 'Caffeine',
    [ProductAdditives.Calcium]: 'Calcium',
    [ProductAdditives.Caramel]: 'Caramel',
    [ProductAdditives.CaramelColor]: 'Caramel Color',
    [ProductAdditives.CaramelE150d]: 'Caramel E150d',
    [ProductAdditives.Carotene]: 'Carotene',
    [ProductAdditives.CayennePepper]: 'Cayenne Pepper',
    [ProductAdditives.Chili]: 'Chili',
    [ProductAdditives.ChiliDressing]: 'Chili Dressing',
    [ProductAdditives.ChiliMayonnaise]: 'Chili Mayonnaise',
    [ProductAdditives.ChiliOil]: 'Chili Oil',
    [ProductAdditives.Quinine]: 'Quinine',
    [ProductAdditives.Chlorophyll]: 'Chlorophyll',
    [ProductAdditives.CitricAcid]: 'Citric Acid',
    [ProductAdditives.CitrusAcid]: 'Citrus Acid',
    [ProductAdditives.CarbonDioxide]: 'Carbon Dioxide (CO₂)',
    [ProductAdditives.CocktailSauce]: 'Cocktail Sauce',
    [ProductAdditives.Curry]: 'Curry',
    [ProductAdditives.CurryPaste]: 'Curry Paste',
    [ProductAdditives.CurryPowder]: 'Curry Powder',
    [ProductAdditives.CurryCreamSauce]: 'Curry Cream Sauce',
    [ProductAdditives.Fragrance]: 'Fragrance',
  },
};
